import './App.css';
import ToDoApp from "./components/ToDoApp";

function App() {
  return (
   <div className="container is-fluid">
      <ToDoApp />
    </div>
  );
}

export default App;
